import { render, staticRenderFns } from "./invasion-details.vue?vue&type=template&id=9534b75e&scoped=true&lang=pug&"
import script from "./invasion-details.vue?vue&type=script&lang=js&"
export * from "./invasion-details.vue?vue&type=script&lang=js&"
import style0 from "./invasion-details.vue?vue&type=style&index=0&id=9534b75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534b75e",
  null
  
)

export default component.exports